export default {
  name: 'storyCard',

  components: {},
  props: ['storyId', 'storyDetails'],

  mixins: [],

  data() {
    return {
      hostUrl: '',
    };
  },

  methods: {
    getHostUrl() {
      this.hostUrl = window.location.host;
    },
    formatDateString(dateString) {
      const date = new Date(dateString);
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return date.toLocaleDateString(undefined, options);
    },
  },
  mounted() {
    this.getHostUrl();
  },
};
